export default {
  messages: {
    delete_provider_details: '<strong>Provider:</strong> {{providerName}}<br /><strong>Tenant ID:</strong> {{tenantId}}'
  },
  litmos: {
    registration_not_completed_title: 'Complete your registration',
    registration_not_completed_msg:
      'Your learning space is ready.<br/><action>Send an invite email</action> to complete registration.',
    new_course_assigned_title: 'New course assigned',
    new_course_assigned_msg:
      'A new course is assigned to you: {{courseName}}.<br/><action>Start the course</action> to get more out of Exposure Management.',
    course_incomplete_title: 'Continue your training',
    course_incomplete_msg:
      'Your training is in progress.<br/><action>Resume your course</action> to get more out of Exposure Management.',
    email_notification_success: 'Invite sent. Check your inbox to complete registration.',
    email_notification_error: 'Failed to send E-Learning registration invite.'
  }
};
